import React from 'react'

import classnames from 'classnames'
import fetcher from "../../../fetcher";
import Stack from "@mui/material/Stack";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../../HomePage/HomePage";
import {useFetchResource} from "../../../hooks/useFetchResource";
import Checkbox from "@mui/material/Checkbox";
import {DealModal} from "../../PricingListPage/DealModal";
import {useModalsStore} from "../../../stores/modalsStore";

export const SelectMiniDealCard = ({ dealId, isSelected, setSelected }) => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const [dealState, setDealState] = useFetchResource(fetcher.getDeal, dealId)
    const openModal = useModalsStore((state) => state.openModal)

    if (!dealState) return null;

    const car_detail = dealState.car_detail

    return (
        <Stack
            direction={isTabletOrMobile ? 'column' : 'row'}
            alignItems="center"
            className={classnames('SelectMiniDealCard', {
                isPurchase: dealState.is_purchase
            })}
            onClick={() => {
                openModal({
                    id: "DealModal",
                    element: DealModal,
                    props: {id: dealId}
                })
            }}
        >
            <Checkbox
                className={'payment-row_value'}
                onClick={e => e.stopPropagation()}
                onChange={(e) => setSelected(dealId, dealState)}
                checked={isSelected}
            />
            <div>
                {car_detail.year} {car_detail.make} {car_detail.model}
                <br/>
                ${dealState.formatted_quote.monthly_payment}
                {" "}/month {dealState.profit.toDollarFormat()} profit
            </div>
        </Stack>
    )
}